import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
// import "../leaflet.css";

import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import clsx from "clsx";

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
});

L.Marker.prototype.options.icon = DefaultIcon;

const Map = ({ posts, setSelectedPost }) => {
  const renderTags = (tags) => {
    if (!tags) return;
    return tags.map((tag) => {
      return (
        <a href={tag.link} key={tag.term_id} className={clsx("mr-2")} style={{ marginRight: "1rem" }}>
          <span key={tag.slug} className="tag">
            {tag.name}
          </span>
        </a>
      );
    });
  };

  const renderTerms = (allTerms) => {
    if (!allTerms || allTerms.length === 0) return;

    const topLevelTerms = allTerms.filter((term) => term.parent === 0);
    let paths = [];
    const walk = (terms, allTerms) => {
      return terms.forEach((term) => {
        paths.push(
          <a href={term.link} key={term.term_id}>
            {term.name}
          </a>
        );
        const children = allTerms.filter((child) => child.parent === term.term_id);
        if (children.length > 0) {
          paths.push(" > ");
          walk(children, terms);
        } else {
          paths.push("\n");
        }
      });
    };

    walk(topLevelTerms, allTerms);
    return paths;
  };

  const renderMarkers = (posts) =>
    posts.map((post) => {
      return (
        <Marker
          position={[post.punkt.lat, post.punkt.lng]}
          key={post.post_id}
          eventHandlers={{
            popupopen: () => {
              setSelectedPost(post)
            },
            popupclose: () => {
              setSelectedPost(null)
            },
          }}
        >
          <Popup>
            <div>
              <a href={post.guid} target="_blank" rel="noreferrer">
                <h2>{post.post_title}</h2>
              </a>
              {/* <p className={clsx('text-xs')}>{post.post_type}</p> */}
              {/* <p className={clsx("text-xs", "m-0", "mb-2")}>{post.post_date}</p> */}
              <small>Tagi:</small>
              <div className={clsx("max-w-full", "mb-2")}>{renderTags(post.tags)}</div>
              <small>Kategorie:</small>
              <div>{renderTerms(post.terms)}</div>
            </div>
          </Popup>
        </Marker>
      )
    });

  return (
    <div style={{ height: "500px", width: "100%" }}>
      <MapContainer
        center={[52.227269238906345, 21.007926923339856]}
        zoom={8}
        scrollWheelZoom={false}
        style={{ height: "100%", width: "100%", zIndex: 3 }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {renderMarkers(posts)}
      </MapContainer>
    </div>
  );
};

export default Map;
